export default __webpack_public_path__ + "images/video-calling-step-1_2x.94b57b1111ec99ae53ee7234e086f4af.png";